import { Services } from '@omnia/ui/src/lib'
import { getBemClassBuilder } from '@omnia/ui/src/lib/lumos-plus/utils/get-bem-class-builder'
import { FilmContextComponent, FilmImageComponent, ModalMode, useFilmContext } from '@vista-digital/occ-ui'
import { Modal } from '@vista-digital/occ-ui/src/lib/subcomponents/modal/modal'
import type { FC, PropsWithChildren } from 'react'
import { Link } from 'react-router-dom-v7'
import type { FilmPopup } from '../models/popup.types'

const ComponentName = 'FilmPopupModal'
const b = getBemClassBuilder(ComponentName)

interface FilmPopupModalProps {
    popup: FilmPopup
    onClose: VoidFunction
}

export const FilmPopupModal: FC<FilmPopupModalProps> = ({ popup, onClose }) => {
    return (
        <Modal className={b.block()} show onClose={onClose} mode={ModalMode.Overlay}>
            <FilmContextComponent filmId={popup.film.key}>
                <FilmLink onClick={onClose}>
                    <FilmImageComponent cdnOptions={{ filmImage: { width: 800 } }} />
                </FilmLink>
            </FilmContextComponent>
        </Modal>
    )
}

const FilmLink: FC<PropsWithChildren<{ onClick: VoidFunction }>> = ({ children, onClick }) => {
    const { film } = useFilmContext()

    if (!film) {
        return <>{children}</>
    }

    const filmDetailsUrl = Services.UrlService.getFilmDetailsUrl(film)

    return (
        <Link to={filmDetailsUrl} onClick={onClick}>
            {children}
        </Link>
    )
}

FilmPopupModal.displayName = ComponentName
